export const SET_DOCUMENT_CATEGORY = 'setDocumentCategory';
export const SET_DOCUMENT_TYPE = 'setDocumentType';
export const SET_DOCUMENT_ERROR = 'setDocumentError';
export const SET_DOCUMENT_UPLOADING = 'setDocumentUploading';
export const SET_AXIOS_REQUEST_CANCELER = 'setAxiosRequestCanceler';
